const login = {
  logoFlavor: "Connectez-vous à votre espace",
  forgottenPasswordButton: "Mot de passe oublié ?",
  forgottenPasswordBackButton: "Revenir à l'authentification",
  passwordResetMessage: "Un mail contenant votre nouveau mot de passe vous a été envoyé."
}

export default login;
